<template>
  <res-form
    title="Resolución Exenta UGDP-S"
    type-document="RESUGDPS"
  />
</template>
<script>
import ResForm from '@/febos/global/customDocuments/vistas/empresas/72235100-2/components/ResForm';

export default {
  name: 'RESUGDPS',
  components: { ResForm }
};
</script>
